import type { ModerationState } from '../types'

export type PublishButtonState =
  | 'unknown'
  | 'error'
  | 'draft'
  | 'pending'
  | 'rejected'
  | 'failed'
  | 'live'
  | 'update'
  | 'update_rejected'

/** Вид кнопки публикации по состоянию проверки. Опубликованный курс без несданных
 *  правок — `live` (старый отказ публикации не про черновик); с несданными —
 *  `update`, а `update_rejected` только после отказа именно обновления.
 *  `error` — первая загрузка упала и данных нет: кнопка обязана остаться живой,
 *  иначе строка «Не удалось загрузить…» с «Повторить» в окне публикации недостижима. */
export const publishButtonState = (
  m: ModerationState | undefined,
  isError = false,
): PublishButtonState => {
  if (!m) return isError ? 'error' : 'unknown'
  if (m.review?.status === 'pending') return 'pending'
  if (m.visibility !== 'unpublished') {
    if (!m.hasUnsubmittedChanges) return 'live'
    return m.review?.kind === 'update' && m.review.status === 'rejected'
      ? 'update_rejected'
      : 'update'
  }
  if (m.review?.status === 'rejected') return 'rejected'
  if (m.review?.status === 'failed') return 'failed'
  return 'draft'
}
